import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { ContactFooter } from "./components/ContactFooter";
import { ScrollManager } from "./components/ScrollManager";
import { Home } from "./pages/Home";
import { Thoughts } from "./pages/Thoughts";
import { ThoughtPost } from "./pages/ThoughtPost";
import { CaseStudy } from "./pages/CaseStudy";
import { NotFound } from "./pages/NotFound";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmcds7wbdabr">
      <ScrollManager data-id="element-1" data-mp="2mmvjmq8ow89f" />
      <div className="relative w-full bg-espresso" data-id="element-2" data-mp="2mndna7xolord">
        <a href="#main-content" className="skip-link" data-id="element-3" data-mp="31b8jvzet8d9q">
          Skip to content
        </a>
        <Header data-id="element-4" data-mp="2wka02pum4x1q" />
        <Routes data-id="element-5" data-mp="2wjqft2hhpwkj">
          <Route path="/" element={<Home data-id="element-7" data-mp="2whx9joashed2" />} data-id="element-6" data-mp="2wj8e3qc26q58" />
          <Route path="/thoughts" element={<Thoughts data-id="element-9" data-mp="28tme50nv46w6" />} data-id="element-8" data-mp="28ufpyg1ohml6" />
          <Route path="/thoughts/:slug" element={<ThoughtPost data-id="element-11" data-mp="23vcjqs9ypabm" />} data-id="element-10" data-mp="28sutgkvsztko" />
          <Route path="/work/:id" element={<CaseStudy data-id="element-13" data-mp="23utb6267bya9" />} data-id="element-12" data-mp="23w4gi6fape3h" />
          <Route path="*" element={<NotFound data-id="element-15" data-mp="3ik7k0rkruvvx" />} data-id="element-14" data-mp="23ti7s3go4sjo" />
        </Routes>
        <ContactFooter data-id="element-16" data-mp="3ijfx0558q6h9" />
      </div>
    </BrowserRouter>;
}